import script from "./itemV3Width.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV3Width.vue?vue&type=script&setup=true&lang=ts"

import "./itemV3Width.vue?vue&type=style&index=0&id=d5157058&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5157058"]])

export default __exports__